const ORGANIZATION_LEVEL = {
  ROOT_LEVEL: 'Sistema',
  CENTRAL_LEVEL: 'Nivel Central',
  INTERMEDIATE_LEVEL: 'Nivel Intermedio',
  BASE_LEVEL: 'Nivel Base',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const ORGANIZATION_LEVEL_ENUM = Object.keys(ORGANIZATION_LEVEL);

const ROOT_LEVEL = ORGANIZATION_LEVEL_ENUM[0];
const CENTRAL_LEVEL = ORGANIZATION_LEVEL_ENUM[1];
const INTERMEDIATE_LEVEL = ORGANIZATION_LEVEL_ENUM[2];
const BASE_LEVEL = ORGANIZATION_LEVEL_ENUM[3];

/**
 * Defines the enum values that can be used in the management operations.
 *
 * @type {string[]}
 */
const USABLE_ORGANIZATION_LEVEL_ENUM = ORGANIZATION_LEVEL_ENUM.filter((item) => item !== ROOT_LEVEL);

/**
 * Defines the enum values that can be assigned in the management operations.
 *
 * @type {string[]}
 */
const ASSIGNABLE_ORGANIZATION_LEVEL_ENUM = USABLE_ORGANIZATION_LEVEL_ENUM.filter((item) => item !== CENTRAL_LEVEL);

/**
 * Retrieves the levels that are, hierarchically speaking, are under the given level.
 *
 * @param level The level whose children will be returned.
 *
 * @returns {[string, string]|[string, string, string]|*[]|[string]}
 */
const getChildren = (level) => {
  switch (level) {
    case ROOT_LEVEL:
      return [CENTRAL_LEVEL, INTERMEDIATE_LEVEL, BASE_LEVEL];
    case CENTRAL_LEVEL:
      return [INTERMEDIATE_LEVEL, BASE_LEVEL];
    case INTERMEDIATE_LEVEL:
      return [BASE_LEVEL];
    default:
      return [];
  }
};

/**
 * Checks whether the given level is, hierarchically speaking, within the also specified parent.
 *
 * @param parent The parent to check its children.
 * @param level The level to check if belongs to the parent's children.
 *
 * @returns {boolean} <b>True</b> if and only if the level belongs to the parent's children, <b>false</b> otherwise.
 */
const isUnder = (parent, level) => !!getChildren(parent).find((item) => item === level);

export {
  ORGANIZATION_LEVEL,
  ORGANIZATION_LEVEL_ENUM,
  ROOT_LEVEL,
  CENTRAL_LEVEL,
  INTERMEDIATE_LEVEL,
  BASE_LEVEL,
  USABLE_ORGANIZATION_LEVEL_ENUM,
  ASSIGNABLE_ORGANIZATION_LEVEL_ENUM,
  getChildren,
  isUnder,
};
